import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CustomTabs from "../../components/Shared/CustomTabs";
import { isActivePath } from "./sideBar/SideBar";

const NavbarTabs = ({ childrens, setChildrens, setNavMenuOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const tabs = useMemo(() => {
    return (
      childrens?.children?.map((item) => ({
        name: item.labelKey || item.label,
        content: null,
      })) || []
    );
  }, [childrens, i18n.language]);

  const activeTabIndex = useMemo(() => {
    // First: check if current path starts with a tab's path (exact or sub-route)
    const index = childrens?.children?.findIndex((item) =>
      isActivePath(item, location),
    );
    if (index !== -1) return index;

    // Second fallback: check if any tab's path is contained in the current URL
    // This handles create/edit sub-pages like /manager/create/receipt/voucher
    const fallbackIndex = childrens?.children?.findIndex(
      (item) =>
        item?.path &&
        location.pathname.includes(item.path.replace("/manager/", "")),
    );
    if (fallbackIndex !== -1) return fallbackIndex;

    return 0;
  }, [childrens, location]);

  const handleTabChange = (index) => {
    const item = childrens?.children?.[index];
    if (item) {
      if (item?.children?.length > 0) setChildrens(item.children);
      navigate(item.path);
      // setNavMenuOpen(false) // Optional if passing this prop
    }
  };

  if (!tabs || tabs.length <= 1) return null;

  return (
    <div className="px-4 bg-white  sticky top-[50px] z-[990]">
      <CustomTabs
        tabs={tabs}
        activeTabIndex={activeTabIndex}
        setActiveTabIndex={handleTabChange}
        wrapperClassName="mt-0"
        navClassName="mb-0"
      />
    </div>
  );
};

export default NavbarTabs;
